<template>
  <div class="add-multiple-seat-modal-component">
    <v-row class="rows-colls">
      <v-text-field variant="outlined" :label="$t('seatEditor.addMultipleSeatModal.content.startCoordX')" type="number" v-model="gridAttrs.startCoordX"></v-text-field>
      <v-text-field variant="outlined" :label="$t('seatEditor.addMultipleSeatModal.content.startCoordY')" type="number" v-model="gridAttrs.startCoordY"></v-text-field>
      <v-text-field variant="outlined" :label="$t('seatEditor.addMultipleSeatModal.content.endCoordX')" type="number" v-model="gridAttrs.endCoordX"></v-text-field>
      <v-text-field variant="outlined" :label="$t('seatEditor.addMultipleSeatModal.content.endCoordY')" type="number" v-model="gridAttrs.endCoordY"></v-text-field>
    </v-row>
    <v-row class="indexes-start">
      <v-switch :label="gridAttrs.isFromRight == false ? $t('seatEditor.addMultipleSeatModal.content.fromLeft') : $t('seatEditor.addMultipleSeatModal.content.fromRight')" v-model="gridAttrs.isFromRight"></v-switch>
      <v-switch :label="gridAttrs.isRowMode == false ? $t('seatEditor.addMultipleSeatModal.content.countFromRow') : $t('seatEditor.addMultipleSeatModal.content.countFromCol')" v-model="gridAttrs.isRowMode"></v-switch>
    </v-row>
    <v-col class="button-col">
      <v-btn @click="handleBack"> {{ $t('seatEditor.addMultipleSeatModal.buttons.back') }} </v-btn>
      <v-btn color="primary" @click="handleGenerateGrid"> {{ $t('seatEditor.addMultipleSeatModal.buttons.generate') }} </v-btn>
    </v-col>
  </div>
</template>

<script>
export default {
  name: 'AddMultipleSeatModalComponent',
  data() {
    return {
      gridAttrs: {
        rowNumber: undefined,
        colNumber: undefined,
        startNumber: undefined,
        retryEveryRow: false,
        isFromRight: false,
        isRowMode: false,
        startCoordX: undefined,
        startCoordY: undefined,
        endCoordX: undefined,
        endCoordY: undefined,
      }
    }
  },
  methods: {
    handleBack() {
      this.$emit('closeModal');
    },
    handleGenerateGrid() {
      this.$emit('createGrid', this.gridAttrs);
    }
  }
}
</script>

<style lang="scss" scoped>
.add-multiple-seat-modal-component {
  .rows-colls {
    .v-text-field {
      width: 40%;
      margin: 0 12px;
    }
  }
  .indexes {
    .v-text-field {
      width: 40%;
      margin: 0 12px;
    }
    .v-checkbox {
      width: 40%;
      margin: 0 12px;
    }
  }
  .indexes-start {
    margin-bottom: 20px;
    .v-switch {
      margin: 0 12px;
      height: 40px;
    }
  }
  .button-col {
    display: flex;
    justify-content: space-between;
  }
}
</style>